<template>
  <div class="iv-message">
    <div class="iv-main-width iv-p-t-20">
        <SearchLayout :list="searchList" :spreadType="2" @on-search="onSearch"></SearchLayout>
        <p class="iv-heng"></p>
      <template v-if="show">
        <div class="iv-box">
          <Button style="margin-left: 8px" type="ghost" class="iv-cancel iv-weidu" noIcon
          @click="setSomeRead"
          >批量已读</Button>
          <Button class="iv-tijiao iv-yidu" type="ghost" noIcon @click="setAllRead">全部设为已读</Button>
        </div>
      <TreeList
        class="iv-m-t-12 iv-fs-14"
        autoHeight
        noSearch
        ref="treeList"
        :columns="columns"
        :showTree="false"
        :showSelect="true"
        :showDelete="false"
        :showEdit="false"
        :showPage="true"
        :keepPage="true"
        :immediateForce="true"
        :listData="listData"
        :url="'api-uum/innermessage/my/list'"
        @on-selection-change="onSelectionChange">
      </TreeList>
      </template>
      <NoData v-else message="暂无消息"></NoData>
    </div>
  </div>
</template>

<script>
import columns from './columns'
import searchList from './searchList'
import NoData from '@/components/no-data'
import TreeList from '@/components/drag-table-inline'
import SearchLayout from '@/components/search-layout'
// import { cloneDeep } from 'lodash'
export default {
  data () {
    return {
      operationList: [],
      show: true,
      columns: [],
      rules: [],
      selectionChange: [],
      tableData: [],
      systemList: [],
      systemOptionList: [],
      innermessageIds: [],//存储批量消息ID
      searchParams: {},
      listData: {},
      listMessage: [],
      count: 0
    }
  },
  provide () {
    return {
      operateClick: this.operateClick
    }
  },
  async created () {
    this.columns = columns.call(this)
    this.searchList = searchList.call(this)
  },
  methods: {
    getNnreadList () {
      this.$ajax({
        url: '/api-uum/innermessage/unreadNumber/get',
        method: 'get',
      }).then((data) => {
        this.count = data.data.data.count
        this.$emit('forceRender', this.count)
        this.$methods('treeList', 'forceRender')
      })
    },
    // 设置为已读/批量设置已读
    getReadInnermessage (ids) {
      this.$ajax({
        url: '/api-uum/innermessage/read/update',
        method: 'put',
        data: {
          innerMessageIds: ids
        }
      }).then((data) => {
        this.getNnreadList()
        this.$methods('treeList', 'forceRender')
        this.innermessageIds = []
      })
    },
    // 设为全部已读
    getAllRead() {
      this.$ajax({
        url: '/api-uum/innermessage/allread/update',
        method: 'put',
        data: {}
      }).then((data) => {
        this.getNnreadList()
        this.$methods('treeList', 'forceRender')
      })
    },
    //处理跳转对应路由
    JumpDisposeMsg (innerMsgId, type) {
      let url =`/api-uum/innermessage/disposeMsg/get?innerMsgId=${innerMsgId}`+`&access_token=${sessionStorage.getItem('token')}`
      window.open(url)
      setTimeout(()=>{
        this.getNnreadList()
      },1000)
    },
    // 全部设置为已读
    setAllRead () {
      this.getAllRead()
    },
    //设置部分已读
    setSomeRead () {
      if(this.innermessageIds.length == 0) {
        this.$Message.error('请先选择');
      } else {
        this.getReadInnermessage(this.innermessageIds)
      }
    },
    //搜索
    onSearch (params, type) {
      this.listData = Object.assign({}, params)
      this.$methods('treeList', 'forceRender')
    },
    // 选择消息时
    onSelectionChange (list) {
      this.listMessage = list
      this.innermessageIds = list.map(item => {
        return item.innerMessageId
      })
      this.selectionChange = list
    },
    operateClick (item, type) {
      switch (type) {
        case '处理':
          this.JumpDisposeMsg(item.innerMessageId, type)
          break
        case '设为已读':
          this.getReadInnermessage(item.innerMessageId)
          break
        default:
          this.setReadMsg(item, type)
          break
      }
    },
  },
  components: {
    NoData,
    TreeList,
    SearchLayout
  }
}
</script>

<style lang="scss" scoped>
.iv-message {
  height: 100%;;
  background-color: #fff;
  /deep/ .iv-drag-table {
    .ivu-table-row {
      .ivu-table-cell {
        font-size: 14px !important;
        color: rgba($color: #000000, $alpha: 0.65);
      }
    }
  }
}
.iv-toubu {
  display: flex;
  width: 1200px;
  flex-wrap: wrap;
  // justify-content: space-around;
}
.iv-form {
  width: 400px;
  display: inline-block;
  justify-content: space-between;
}
.iv-form-kuang, .ivu-date-picker {
  width: 302px !important;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
}
/deep/ .ivu-input {
  height: 40px !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
/deep/ .ivu-select-placeholder {
  height: 40px !important;
  line-height: 40px !important;
}
/deep/ .ivu-select-selection {
  height: 40px !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 40px;
}
/deep/ .ivu-select-arrow {
  margin-top: -5px;
}
/deep/ .ivu-form-item-label {
  color: rgba($color: #000000, $alpha: 0.65);
  font-size: 14px;
}
.iv-botton {
  float: right;
  // margin-top: 10px;
  width: 400px;
}
.iv-tijiao {
  border-radius: 8px;
  width: 88px;
  height: 40px;
  margin-left: 116px;
}
.iv-cancel {
  border-radius: 8px;
  width: 88px;
  height: 40px;
}
.iv-heng {
  height: 1px;
  background: rgba(0, 0, 0, 0.15);
  // border: 1px solid rgba(0, 0, 0, 0.15);
  margin: 20px 0;
}
.iv-box {
  width: 1200px;
  height: 40px;
  .iv-yidu {
    float: right;
    width: 128px;
  }
  .iv-weidu {
    float: right;
    width: 96px;
  }
}
</style>
